import { render, staticRenderFns } from "./SobreOCursoCards.vue?vue&type=template&id=0b633b5c&"
import script from "./SobreOCursoCards.vue?vue&type=script&lang=js&"
export * from "./SobreOCursoCards.vue?vue&type=script&lang=js&"
import style0 from "./SobreOCursoCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VIcon,VLayout})
